/**
 * DemoBanner — the persistent "Demo — sample data only" marker required by the
 * scope (Part A acceptance criterion #1). Fixed to the top of the viewport on
 * every screen so screenshots self-label and the demo can never be mistaken for
 * the real clinical product.
 */
export function DemoBanner() {
  return (
    <div
      role="status"
      className="relative z-[60] flex items-center justify-center gap-2 border-b border-[var(--color-border-gold)] bg-[var(--color-bg-deep)] px-4 py-1.5"
    >
      <span aria-hidden className="text-[var(--color-gold-soft)]">●</span>
      <span className="font-mono text-[10px] uppercase tracking-[0.22em] text-[var(--color-gold-soft)]">
        Demo — sample data only · nothing is saved
      </span>
    </div>
  );
}
